// src/Privacy.js
import React from "react";

export default function Privacy() {
  return (
    <div style={{ maxWidth: 900, margin: "60px auto", padding: "0 20px" }}>
      <h1>Privacy Policy</h1>

      <p>
        At <strong>hellastay</strong>, your privacy is important to us. This policy explains how we collect,
        use, share, and protect your personal information when you use our platform (as a guest or host).
      </p>

      <p style={{ color: "rgba(0,0,0,0.65)", fontSize: 13, marginTop: 10 }}>
        Last updated: <strong>2026</strong>
      </p>

      <h2>1. Who We Are</h2>
      <p>
        <strong>hellastay</strong> is a platform that connects guests with hosts for short-stay bookings.
        We act as a marketplace and help facilitate communication, reservations, and payments.
      </p>

      <h2>2. Information We Collect</h2>
      <ul>
        <li>
          <strong>Account data</strong>: email address, login details (password is stored hashed), language
          preferences, and basic profile information you provide.
        </li>
        <li>
          <strong>Booking & hosting data</strong>: booking requests, stay dates, number of guests, messages
          between guests and hosts, property listings and related details.
        </li>
        <li>
          <strong>Payment-related data</strong>: transaction references and payment status.{" "}
          <strong>We do not store your full card details</strong>. Payments are processed by a third-party
          payment provider (e.g., Stripe).
        </li>
        <li>
          <strong>Technical data</strong>: IP address, device/browser information, approximate location
          (derived from IP), logs, and security-related events.
        </li>
        <li>
          <strong>Cookies</strong>: small files used for login/session, security, and performance.
        </li>
      </ul>

      <h2>3. How We Use Your Information</h2>
      <ul>
        <li>To create and manage accounts, authenticate users, and keep sessions secure.</li>
        <li>To provide booking and hosting services, including communication between guests and hosts.</li>
        <li>
          To facilitate payments and (where applicable) an escrow-style release of payouts after check-in
          confirmation.
        </li>
        <li>To prevent fraud, abuse, and unauthorized access.</li>
        <li>To improve and maintain the platform (performance, features, support).</li>
        <li>To comply with legal obligations (e.g., accounting, disputes, lawful requests).</li>
      </ul>

      <h2>4. Legal Bases (GDPR)</h2>
      <ul>
        <li>
          <strong>Contract</strong>: processing required to provide the service (account, bookings, support).
        </li>
        <li>
          <strong>Legitimate interests</strong>: security, fraud prevention, and improving the platform.
        </li>
        <li>
          <strong>Legal obligation</strong>: where we must keep records or respond to lawful requests.
        </li>
        <li>
          <strong>Consent</strong>: where required (e.g., non-essential cookies or marketing emails, if enabled).
        </li>
      </ul>

      <h2>5. Payments & Escrow-Style Release</h2>
      <p>
        Payments on <strong>hellastay</strong> may be processed by a third-party payment provider such as{" "}
        <strong>Stripe</strong>. We receive limited payment-related information (e.g., transaction IDs and status)
        to operate the service.
      </p>
      <p>
        If an escrow-style flow is enabled, funds may be held temporarily and released to the host after check-in
        confirmation (e.g., using a check-in code) and/or after a short grace period, unless an issue is reported.
      </p>

      <h2>6. Sharing Your Data</h2>
      <p>We share data only as needed to run the platform:</p>
      <ul>
        <li>
          <strong>Between guests and hosts</strong>: relevant booking details needed to complete a reservation.
        </li>
        <li>
          <strong>Service providers</strong>: hosting/infrastructure, analytics (if enabled), customer support
          tools, email delivery, and payment processors (e.g., Stripe).
        </li>
        <li>
          <strong>Legal and safety</strong>: if required by law, court order, or to protect users and the platform.
        </li>
      </ul>
      <p>
        <strong>We do not sell your personal data.</strong>
      </p>

      <h2>7. Cookies</h2>
      <p>
        We use cookies and similar technologies mainly to keep you logged in, remember preferences, and protect the
        platform. You can control cookies through your browser settings. Some cookies are necessary for the website
        to function.
      </p>

      <h2>8. Data Retention</h2>
      <p>
        We keep your personal data only as long as needed for the purposes described above. For example, we may keep
        certain transaction and booking records for legal/accounting reasons. You can request deletion of your
        account, subject to required retention obligations.
      </p>

      <h2>9. Security</h2>
      <p>
        We use reasonable security measures to protect your data (e.g., encrypted transport/HTTPS, secure storage,
        access controls). However, no online system can be guaranteed 100% secure.
      </p>

      <h2>10. Your Rights</h2>
      <p>
        Depending on your location (including the EU/EEA), you may have rights to access, correct, delete, restrict,
        or object to the processing of your personal data, and to request data portability.
      </p>

      <h2>11. International Transfers</h2>
      <p>
        Some service providers may process data outside your country. Where applicable, we use appropriate safeguards
        under data protection laws.
      </p>

      <h2>12. Charity Pledge (Donation Commitment)</h2>
      <p>
        We want <strong>hellastay</strong> to have a positive impact.{" "}
        <strong>After the platform is monetized</strong>, we intend to donate a percentage of our net profit to
        charitable causes. We will publicly share details (percentage, beneficiaries, and reporting) once the
        monetization model is fully launched and finalized.
      </p>

      <h2>13. Changes to This Policy</h2>
      <p>
        We may update this policy from time to time. If changes are significant, we will provide notice on the
        website. The “Last updated” date will be revised accordingly.
      </p>

      <h2>14. Contact</h2>
      <p>
        Email: <strong>hellasstay@gmail.com</strong>
      </p>
    </div>
  );
}